import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';

const PresentAbsentSave = ({ timingId, runClassDate, weekDayName, timeIndex, onChange, onClose, hideLegalAbsent }) => {
    const [loading, setLoading] = useState(true);
    const [presentAbsent, setPresentAbsent] = useState(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
      setLoading(true);
      var params = {login:util.getTrustedUser(), runClassDate:runClassDate, timingId:timingId};
      var url = config.Server+`/school/present-absent/timing/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response;
                  //legalAbsent
                  var pr = {...response.data};
                  for(var i=0;i<pr.studentStates.length;i++){
                    if(pr.studentStates[i].isPresent){
                        pr.studentStates[i]["legalAbsent"] = false;
                        pr.studentStates[i]["unLegalAbsent"] = false;
                    }
                    else{
                        pr.studentStates[i]["legalAbsent"] = pr.studentStates[i].isLegalAbsent;
                        pr.studentStates[i]["unLegalAbsent"] = !pr.studentStates[i].isLegalAbsent;
                    }
                  }
                    pr.studentStates.sort((a, b) => {
                        const fn = a.student.lastname.localeCompare(b.student.lastname, 'fa');
                        if (fn !== 0) return fn;
                        return a.student.firstname.localeCompare(b.student.firstname, 'fa');
                    });
                  console.log("present absent resopnse after sort is> ", response);

                  setPresentAbsent(pr);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={saving} />
        )
    }
    const saveItem = function(){
      setSaving(true);
      var tmp = presentAbsent.studentStates;
      var students = [];
      var presentCo = 0;
      var legalAbsentCo = 0;
      var unLegalAbsentCo = 0;
      for(var i=0;i<tmp.length;i++){
        if(tmp[i].isPresent) presentCo++;
        if(tmp[i].legalAbsent) legalAbsentCo++;
        if(tmp[i].unLegalAbsent) unLegalAbsentCo++;
        students.push({studentId:tmp[i].student.id, isPresent:tmp[i].isPresent, isLegalAbsent:tmp[i].legalAbsent, comment:""});
      }
      var params = {login:util.getTrustedUser(), timingId:timingId, runClassDate:runClassDate, students:students};
      var url = config.Server+`/school/present-absent/save`;
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  onChange(timingId, presentCo, legalAbsentCo, unLegalAbsentCo);
                  onClose();                  
                  setSaving(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const onInputChange = function(e, index){
        var val = '';
        val = (e.target && e.target.value) || '';
        var tmp = {...presentAbsent};
        tmp.studentStates[index].comment = val;
        setPresentAbsent(tmp);
    }
    const onCheckboxChange = (e, name, index) => {
        var tmp = {...presentAbsent};
        if(index == -1){
            for(var i=0;i<tmp.studentStates.length;i++){
                if(name == "isPresent"){
                    tmp.studentStates[i].isPresent = true;
                    tmp.studentStates[i].legalAbsent = false;
                    tmp.studentStates[i].unLegalAbsent = false;
                }
                else if(name == "legalAbsent"){
                    tmp.studentStates[i].isPresent = false;
                    tmp.studentStates[i].legalAbsent = true;
                    tmp.studentStates[i].unLegalAbsent = false;
                }
                else if(name == "unLegalAbsent"){
                    tmp.studentStates[i].isPresent = false;
                    tmp.studentStates[i].legalAbsent = false;
                    tmp.studentStates[i].unLegalAbsent = true;
                }
            }
        }
        else{
            if(name == "isPresent"){
                tmp.studentStates[index].isPresent = true;
                tmp.studentStates[index].legalAbsent = false;
                tmp.studentStates[index].unLegalAbsent = false;
            }
            else if(name == "legalAbsent"){
                tmp.studentStates[index].isPresent = false;
                tmp.studentStates[index].legalAbsent = true;
                tmp.studentStates[index].unLegalAbsent = false;
            }
            else if(name == "unLegalAbsent"){
                tmp.studentStates[index].isPresent = false;
                tmp.studentStates[index].legalAbsent = false;
                tmp.studentStates[index].unLegalAbsent = true;
            }
        }
        setPresentAbsent(tmp);
    }
    return (
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت حضور و غیاب" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{presentAbsent.time.schoolClass.name}</td>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{presentAbsent.time.course.name}</td>
                            </tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{presentAbsent.time.teacher.firstname + " " + presentAbsent.time.teacher.lastname}</td>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0", fontWeight:"bold"}}>
                                    {weekDayName}, &nbsp;{util.SeperateDate(runClassDate)},&nbsp;
                                    {
                                        timeIndex==0 ? <>زنگ اول</>
                                        : timeIndex==1 ? <>زنگ دوم</>
                                        : timeIndex==2 ? <>زنگ سوم</>
                                        : timeIndex==3 ? <>زنگ چهارم</>
                                        : timeIndex==4 ? <>زنگ پنجم</>
                                        : timeIndex==5 ? <>زنگ ششم</>
                                        : <></>
                                    }
                                    </td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{width:"64px", textAlign:"center", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                    حاضر
                                    <br/><Checkbox onChange={(e)=>{onCheckboxChange(e, "isPresent", -1)}} />
                                </th>
                                {
                                    hideLegalAbsent?
                                    <></>
                                    :
                                <th style={{width:"64px", textAlign:"center", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                    غیبت موجه
                                    <br/><Checkbox onChange={(e)=>{onCheckboxChange(e, "legalAbsent", -1)}} />
                                </th>
                                }
                                <th style={{width:"64px", textAlign:"center", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                    {
                                        hideLegalAbsent?
                                        <>غایب</>
                                        :
                                        <>غیبت غیرموجه</>
                                    }                                    
                                    <br/><Checkbox onChange={(e)=>{onCheckboxChange(e, "unLegalAbsent", -1)}} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                presentAbsent.studentStates.map((row, index)=>{
                                    return(
                                    <tr>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            <Checkbox onChange={(e)=>{onCheckboxChange(e, "isPresent", index)}} checked={presentAbsent.studentStates[index].isPresent} />
                                        </td>
                                        {
                                            hideLegalAbsent?
                                            <></>
                                            :
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            <Checkbox onChange={(e)=>{onCheckboxChange(e, "legalAbsent", index)}} checked={presentAbsent.studentStates[index].legalAbsent} />
                                        </td>
                                        }
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            {
                                                hideLegalAbsent?
                                                <Checkbox onChange={(e)=>{onCheckboxChange(e, "unLegalAbsent", index)}} checked={presentAbsent.studentStates[index].unLegalAbsent||presentAbsent.studentStates[index].legalAbsent} />
                                                :
                                                <Checkbox onChange={(e)=>{onCheckboxChange(e, "unLegalAbsent", index)}} checked={presentAbsent.studentStates[index].unLegalAbsent} />
                                            }                                            
                                        </td>
                                    </tr>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>
    )
};

export default PresentAbsentSave;